var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import AutoRefreshingTraits from "./AutoRefreshingTraits";
import CatalogFunctionTraits from "./CatalogFunctionTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import GroupTraits from "./GroupTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
let CatalogFunctionJobTraits = (_dec = primitiveArrayTrait({
  name: "Logs",
  description: "Job logs.",
  type: "string"
}), _dec2 = primitiveTrait({
  name: "Job status",
  description: "Job status.",
  type: "string"
}), _dec3 = primitiveTrait({
  name: "Downloaded results",
  description: "Downloaded results.",
  type: "boolean"
}), _dec4 = primitiveTrait({
  name: "Refresh enabled",
  description: "Toggle for enabling auto refresh. (This overrides Trait in AutoRefreshingTraits)",
  type: "boolean"
}), _dec5 = primitiveTrait({
  name: "Refresh interval",
  description: "How often the job will poll for results, in seconds. (This overrides `AutoRefreshingTraits`)",
  type: "number"
}), _class = class CatalogFunctionJobTraits extends mixTraits(CatalogFunctionTraits, AutoRefreshingTraits, CatalogMemberTraits, LegendOwnerTraits, GroupTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "logs", _descriptor, this);
    _initializerDefineProperty(this, "jobStatus", _descriptor2, this);
    _initializerDefineProperty(this, "downloadedResults", _descriptor3, this);
    _initializerDefineProperty(this, "refreshEnabled", _descriptor4, this);
    _initializerDefineProperty(this, "refreshInterval", _descriptor5, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "logs", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "jobStatus", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "inactive";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "downloadedResults", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "refreshEnabled", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "refreshInterval", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _class);
export { CatalogFunctionJobTraits as default };